// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Instrument+Serif:ital,wght@0,400;1,400&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blog-page {
  max-width: 1120px;
  margin: 0 auto;
  padding: calc(56px + 40px) 24px 88px;
  color: var(--color-text-primary);
  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;
}

.blog-page__hero {
  max-width: 760px;
  margin-bottom: 48px;
}

.blog-page__featured,
.blog-page__card {
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-canvas-surface);
  box-shadow: var(--color-shadow-canvas-frame);
}

.blog-page__kicker {
  margin: 0 0 12px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--color-accent-base);
  opacity: 0.9;
}

.blog-page__title {
  margin: 0;
  line-height: 1.08;
  font-size: clamp(2.35rem, 5vw, 3.9rem);
  letter-spacing: -0.01em;
  font-weight: 400;
  font-family: 'Geist Sans', 'Times New Roman', serif;
  color: var(--color-text-primary);
}

.blog-page__subtitle {
  margin: 16px 0 0;
  max-width: 680px;
  line-height: 1.7;
  font-size: 15px;
  color: var(--color-text-secondary);
}

.blog-page__section-label,
.blog-page__card-type {
  display: inline-flex;
  width: fit-content;
  align-items: center;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.blog-page__featured-section,
.blog-page__articles-section {
  scroll-margin-top: 96px;
}

.blog-page__featured-section,
.blog-page__articles-section {
  margin-bottom: 56px;
}

.blog-page__section-label {
  margin: 0 0 12px;
  padding: 5px 12px;
  border: 1px solid var(--color-accent-base);
  border-radius: 3px;
  color: var(--color-accent-base);
}

.blog-page__section-title {
  margin: 0 0 10px;
  font-family: 'Geist Sans', 'Times New Roman', serif;
  font-size: clamp(1.75rem, 3.3vw, 2.5rem);
  font-weight: 400;
  line-height: 1.12;
  letter-spacing: -0.01em;
}

.blog-page__featured-section {
  margin-bottom: 56px;
}

.blog-page__featured-section .blog-page__section-title,
.blog-page__articles-section .blog-page__section-title {
  margin-bottom: 18px;
}

.blog-page__featured {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0;
  border-radius: 6px;
  overflow: hidden;
  transition: background 0.2s ease, border-color 0.2s ease;
}

.blog-page__featured:hover {
  border-color: var(--color-accent-base);
  background: var(--color-bg-root);
}

.blog-page__featured-cover-link {
  display: block;
  overflow: hidden;
}

.blog-page__featured-cover {
  display: block;
  width: 100%;
  height: 100%;
  min-height: 320px;
  object-fit: cover;
  background: var(--color-bg-canvas-frame);
}

.blog-page__featured-body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 32px;
  gap: 8px;
}

.blog-page__feature-label-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.blog-page__featured-label {
  display: inline-flex;
  align-items: center;
  width: fit-content;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--color-text-on-accent);
  background: var(--color-accent-base);
}

.blog-page__card-type {
  color: var(--color-text-secondary);
}

.blog-page__featured-title {
  margin: 0;
  font-size: clamp(1.6rem, 2.7vw, 2rem);
  line-height: 1.18;
  letter-spacing: -0.005em;
  font-weight: 400;
  font-family: 'Geist Sans', 'Times New Roman', serif;
}

.blog-page__featured-title a {
  color: inherit;
  text-decoration: none;
}

.blog-page__featured-title a:hover {
  text-decoration: underline;
  text-underline-offset: 3px;
}

.blog-page__featured-excerpt {
  margin: 0;
  line-height: 1.7;
  font-size: 14px;
  color: var(--color-text-secondary);
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.blog-page__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 16px;
}

.blog-page__card {
  border-radius: 6px;
  overflow: hidden;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.blog-page__card:hover {
  border-color: var(--color-accent-base);
  background: var(--color-bg-root);
}

.blog-page__cover-link {
  display: block;
  overflow: hidden;
}

.blog-page__cover {
  display: block;
  width: 100%;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  background: var(--color-bg-canvas-frame);
}

.blog-page__card-body {
  padding: 22px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.blog-page__meta-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  font-size: 12px;
  color: var(--color-text-secondary);
}

.blog-page__card-title {
  margin: 0;
  line-height: 1.18;
  font-size: 1.45rem;
  font-weight: 400;
  letter-spacing: -0.005em;
  font-family: 'Geist Sans', 'Times New Roman', serif;
}

.blog-page__card-title a {
  color: inherit;
  text-decoration: none;
}

.blog-page__card-title a:hover {
  text-decoration: underline;
  text-underline-offset: 3px;
}

.blog-page__card-excerpt {
  margin: 0;
  line-height: 1.7;
  font-size: 13px;
  color: var(--color-text-secondary);
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.blog-page__tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 4px;
}

.blog-page__tag {
  border: 1px solid var(--color-border-input);
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 11px;
  line-height: 1.3;
  font-weight: 500;
  color: var(--color-text-secondary);
  background: var(--color-bg-user-bubble);
  transition: border-color 0.2s ease, color 0.2s ease;
}

.blog-page__card:hover .blog-page__tag,
.blog-page__featured:hover .blog-page__tag {
  border-color: var(--color-accent-base);
  color: var(--color-text-primary);
}

.blog-page__read-more {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: auto;
  padding-top: 6px;
  font-size: 13px;
  font-weight: 600;
  color: var(--color-accent-base);
  text-decoration: none;
  transition: gap 0.2s ease;
}

.blog-page__read-more:hover {
  gap: 8px;
  text-decoration: none;
}

.blog-page__read-more svg {
  transition: transform 0.2s ease;
}

.blog-page__read-more:hover svg {
  transform: translateX(2px);
}

a:focus-visible,
button:focus-visible {
  outline: 2px solid var(--color-text-primary);
  outline-offset: 2px;
}

@media (max-width: 900px) {
  .blog-page__featured {
    grid-template-columns: 1fr;
  }

  .blog-page__featured-cover {
    min-height: 220px;
    aspect-ratio: 16 / 9;
  }

  .blog-page__featured-body {
    padding: 24px;
  }

}

@media (max-width: 720px) {
  .blog-page {
    padding: calc(56px + 24px) 16px 56px;
  }

  .blog-page__hero {
    margin-bottom: 40px;
  }

  .blog-page__grid {
    grid-template-columns: 1fr;
  }

  .blog-page__card-body {
    padding: 18px;
  }

  .blog-page__featured-body {
    padding: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/BlogPage.css"],"names":[],"mappings":"AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,oCAAoC;EACpC,gCAAgC;EAChC,8EAA8E;AAChF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,2CAA2C;EAC3C,0CAA0C;EAC1C,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,sCAAsC;EACtC,uBAAuB;EACvB,gBAAgB;EAChB,mDAAmD;EACnD,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kCAAkC;AACpC;;AAEA;;EAEE,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0CAA0C;EAC1C,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,mDAAmD;EACnD,wCAAwC;EACxC,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,MAAM;EACN,kBAAkB;EAClB,gBAAgB;EAChB,wDAAwD;AAC1D;;AAEA;EACE,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,qCAAqC;EACrC,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,mDAAmD;AACrD;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,kCAAkC;EAClC,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0DAA0D;AAC5D;;AAEA;EACE,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,mDAAmD;AACrD;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,kCAAkC;EAClC,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,2CAA2C;EAC3C,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;EAClC,uCAAuC;EACvC,mDAAmD;AACrD;;AAEA;;EAEE,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;AAEF;;AAEA;EACE;IACE,oCAAoC;EACtC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Instrument+Serif:ital,wght@0,400;1,400&display=swap');\n\n.blog-page {\n  max-width: 1120px;\n  margin: 0 auto;\n  padding: calc(56px + 40px) 24px 88px;\n  color: var(--color-text-primary);\n  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;\n}\n\n.blog-page__hero {\n  max-width: 760px;\n  margin-bottom: 48px;\n}\n\n.blog-page__featured,\n.blog-page__card {\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-canvas-surface);\n  box-shadow: var(--color-shadow-canvas-frame);\n}\n\n.blog-page__kicker {\n  margin: 0 0 12px;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--color-accent-base);\n  opacity: 0.9;\n}\n\n.blog-page__title {\n  margin: 0;\n  line-height: 1.08;\n  font-size: clamp(2.35rem, 5vw, 3.9rem);\n  letter-spacing: -0.01em;\n  font-weight: 400;\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n  color: var(--color-text-primary);\n}\n\n.blog-page__subtitle {\n  margin: 16px 0 0;\n  max-width: 680px;\n  line-height: 1.7;\n  font-size: 15px;\n  color: var(--color-text-secondary);\n}\n\n.blog-page__section-label,\n.blog-page__card-type {\n  display: inline-flex;\n  width: fit-content;\n  align-items: center;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n}\n\n.blog-page__featured-section,\n.blog-page__articles-section {\n  scroll-margin-top: 96px;\n}\n\n.blog-page__featured-section,\n.blog-page__articles-section {\n  margin-bottom: 56px;\n}\n\n.blog-page__section-label {\n  margin: 0 0 12px;\n  padding: 5px 12px;\n  border: 1px solid var(--color-accent-base);\n  border-radius: 3px;\n  color: var(--color-accent-base);\n}\n\n.blog-page__section-title {\n  margin: 0 0 10px;\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n  font-size: clamp(1.75rem, 3.3vw, 2.5rem);\n  font-weight: 400;\n  line-height: 1.12;\n  letter-spacing: -0.01em;\n}\n\n.blog-page__featured-section {\n  margin-bottom: 56px;\n}\n\n.blog-page__featured-section .blog-page__section-title,\n.blog-page__articles-section .blog-page__section-title {\n  margin-bottom: 18px;\n}\n\n.blog-page__featured {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0;\n  border-radius: 6px;\n  overflow: hidden;\n  transition: background 0.2s ease, border-color 0.2s ease;\n}\n\n.blog-page__featured:hover {\n  border-color: var(--color-accent-base);\n  background: var(--color-bg-root);\n}\n\n.blog-page__featured-cover-link {\n  display: block;\n  overflow: hidden;\n}\n\n.blog-page__featured-cover {\n  display: block;\n  width: 100%;\n  height: 100%;\n  min-height: 320px;\n  object-fit: cover;\n  background: var(--color-bg-canvas-frame);\n}\n\n.blog-page__featured-body {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 32px;\n  gap: 8px;\n}\n\n.blog-page__feature-label-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n}\n\n.blog-page__featured-label {\n  display: inline-flex;\n  align-items: center;\n  width: fit-content;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--color-text-on-accent);\n  background: var(--color-accent-base);\n}\n\n.blog-page__card-type {\n  color: var(--color-text-secondary);\n}\n\n.blog-page__featured-title {\n  margin: 0;\n  font-size: clamp(1.6rem, 2.7vw, 2rem);\n  line-height: 1.18;\n  letter-spacing: -0.005em;\n  font-weight: 400;\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n}\n\n.blog-page__featured-title a {\n  color: inherit;\n  text-decoration: none;\n}\n\n.blog-page__featured-title a:hover {\n  text-decoration: underline;\n  text-underline-offset: 3px;\n}\n\n.blog-page__featured-excerpt {\n  margin: 0;\n  line-height: 1.7;\n  font-size: 14px;\n  color: var(--color-text-secondary);\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.blog-page__grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 16px;\n}\n\n.blog-page__card {\n  border-radius: 6px;\n  overflow: hidden;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.blog-page__card:hover {\n  border-color: var(--color-accent-base);\n  background: var(--color-bg-root);\n}\n\n.blog-page__cover-link {\n  display: block;\n  overflow: hidden;\n}\n\n.blog-page__cover {\n  display: block;\n  width: 100%;\n  aspect-ratio: 16 / 9;\n  object-fit: cover;\n  background: var(--color-bg-canvas-frame);\n}\n\n.blog-page__card-body {\n  padding: 22px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.blog-page__meta-row {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 6px;\n  font-size: 12px;\n  color: var(--color-text-secondary);\n}\n\n.blog-page__card-title {\n  margin: 0;\n  line-height: 1.18;\n  font-size: 1.45rem;\n  font-weight: 400;\n  letter-spacing: -0.005em;\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n}\n\n.blog-page__card-title a {\n  color: inherit;\n  text-decoration: none;\n}\n\n.blog-page__card-title a:hover {\n  text-decoration: underline;\n  text-underline-offset: 3px;\n}\n\n.blog-page__card-excerpt {\n  margin: 0;\n  line-height: 1.7;\n  font-size: 13px;\n  color: var(--color-text-secondary);\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.blog-page__tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 4px;\n}\n\n.blog-page__tag {\n  border: 1px solid var(--color-border-input);\n  border-radius: 999px;\n  padding: 4px 10px;\n  font-size: 11px;\n  line-height: 1.3;\n  font-weight: 500;\n  color: var(--color-text-secondary);\n  background: var(--color-bg-user-bubble);\n  transition: border-color 0.2s ease, color 0.2s ease;\n}\n\n.blog-page__card:hover .blog-page__tag,\n.blog-page__featured:hover .blog-page__tag {\n  border-color: var(--color-accent-base);\n  color: var(--color-text-primary);\n}\n\n.blog-page__read-more {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  margin-top: auto;\n  padding-top: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--color-accent-base);\n  text-decoration: none;\n  transition: gap 0.2s ease;\n}\n\n.blog-page__read-more:hover {\n  gap: 8px;\n  text-decoration: none;\n}\n\n.blog-page__read-more svg {\n  transition: transform 0.2s ease;\n}\n\n.blog-page__read-more:hover svg {\n  transform: translateX(2px);\n}\n\na:focus-visible,\nbutton:focus-visible {\n  outline: 2px solid var(--color-text-primary);\n  outline-offset: 2px;\n}\n\n@media (max-width: 900px) {\n  .blog-page__featured {\n    grid-template-columns: 1fr;\n  }\n\n  .blog-page__featured-cover {\n    min-height: 220px;\n    aspect-ratio: 16 / 9;\n  }\n\n  .blog-page__featured-body {\n    padding: 24px;\n  }\n\n}\n\n@media (max-width: 720px) {\n  .blog-page {\n    padding: calc(56px + 24px) 16px 56px;\n  }\n\n  .blog-page__hero {\n    margin-bottom: 40px;\n  }\n\n  .blog-page__grid {\n    grid-template-columns: 1fr;\n  }\n\n  .blog-page__card-body {\n    padding: 18px;\n  }\n\n  .blog-page__featured-body {\n    padding: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
